const clarityTrack = (key, value) => {
  if (window.clarity) {
    window.clarity('set', key, value);
  }
};

const GENERIC_EMAIL_DOMAINS = new Set([
  'gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com',
  'live.com', 'icloud.com', 'me.com', 'msn.com',
]);

export const resolveInstitutionName = ({ institution_code, institution, email } = {}) => {
  if (institution_code) return institution_code;
  if (institution) return institution;
  if (email) {
    const domain = email.split('@')[1]?.toLowerCase();
    if (domain && !GENERIC_EMAIL_DOMAINS.has(domain)) {
      return domain.split('.')[0];
    }
  }
  return 'unknown';
};

export const clarityEvent = (name) => {
  if (window.clarity) {
    window.clarity('event', name);
  }
};

export const identifyUser = (user) => {
  if (window.clarity) {
    window.clarity('identify', String(user.id), null, null, user.email);
  }
};

export const trackUserContext = (user) => {
  clarityTrack('institution_name', user.institutionName || 'unknown');
  clarityTrack('institution_id', String(user.belong_to_user_id || user.id));
  clarityTrack('user_role', user.roleString || String(user.role_id));
};

// Every auth view is one route, reached through canonical URLs, so filtering
// sessions by flow no longer depends on which URL someone arrived by.
export const trackAuthView = (view) => clarityTrack('auth_view', view);

export const trackSessionEndNotice = (reason) => clarityTrack('session_end_reason', reason);

export const trackCourseContext = (course) => {
  clarityTrack('course_id', String(course.id));
  clarityTrack('course_name', course.title || course.name || '');
};

export const trackStageContext = (stageId) => {
  clarityTrack('course_stage', String(stageId));
};

export const trackStageSubmitted = (type) =>
  clarityTrack('stage_submitted', type);

export const trackStageApproved = (approved) =>
  clarityTrack('stage_approved', String(approved));

export const trackFeedbackCompleted = () =>
  clarityTrack('feedback_completed', 'true');

export const trackCourseCompleted = (courseId) =>
  clarityTrack('course_completed', String(courseId));
